/**
 * Shared left-nav active-route highlight styles.
 * Relies on @reach/router Link setting aria-current="page" when the route matches.
 */
export const navActiveStyles = {
  '& a[aria-current="page"] .MuiListItemButton-root': {
    backgroundColor: 'rgba(25, 118, 210, 0.12) !important',
  },
  '& a[aria-current="page"] .MuiListItemText-primary': {
    fontWeight: 600,
    color: '#1565c0',
  },
  // ListItemButton rendered as Reach Link (component={Link})
  '& .MuiListItemButton-root[aria-current="page"]': {
    backgroundColor: 'rgba(25, 118, 210, 0.12) !important',
  },
  '& .MuiListItemButton-root[aria-current="page"] .MuiListItemText-primary': {
    fontWeight: 600,
    color: '#1565c0',
  },
  '& .MuiListItemButton-root.Mui-selected': {
    backgroundColor: 'rgba(25, 118, 210, 0.12) !important',
  },
  '& .MuiListItemButton-root.Mui-selected .MuiListItemText-primary': {
    fontWeight: 600,
    color: '#1565c0',
  },
};

export function isNavPathActive(pathname, to, { prefix = false } = {}) {
  if (!pathname || !to) return false;
  const path = String(pathname).replace(/\/$/, '') || '/';
  const target = String(to).replace(/\/$/, '') || '/';
  if (path === target) return true;
  if (prefix && path.startsWith(`${target}/`)) return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/components/leftnav/navActiveStyles.js